<template>
  <div>
    <v-data-table
      mobile-breakpoint="0"
      :headers="headers"
      :items="groupedConfigs"
      :options.sync="tableOptions"
      item-key="_id"
      :loading="isLoading"
      loading-text="Đang tải danh sách..."
      disable-sort
      :footer-props="footerTable"
    >
      <template v-slot:item.creator_role="{ item }">
        {{ item.creator_role.description || '---' }}
      </template>

      <template v-slot:item.receivers="{ item }">
        {{ item.receiver_role.description || '---' }}
      </template>

      <template v-slot:item.actions="{ item }">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn icon v-bind="attrs" v-on="on">
              <v-icon>mdi-dots-vertical</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item @click="confirmDelete(item)">
              <v-list-item-title>Xoá quyền</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="text-h6 text-uppercase">XÓA QUYỀN CÔNG VIỆC</v-card-title>

        <v-card-text v-if="selectedItemId" class="px-6 pt-0 pb-2 grey--text text--darken-1">
          Bạn có chắc chắn muốn xoá quyền giao việc từ
          <strong>{{ selectedItemId.creator_role.description || '---' }}</strong> cho
          <strong>{{ selectedItemId.receiver_role.description || '---' }}</strong> không?
        </v-card-text>
        <v-card-actions class="d-flex justify-space-between pa-6">
          <v-btn class="text-none text-uppercase" @click="dialog = false" :disabled="isDeleting" outlined>Không</v-btn>
          <v-btn color="primary text-none text-uppercase" elevation="0" :loading="isDeleting" @click="deleteMapping"
            >Có</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  props: {
    configsProp: Array,
    isLoading: Boolean,
    pagination: {
      type: Object,
      default: () => ({
        page: 1,
        limit: 30,
        total: 0,
      }),
    },
  },
  data() {
    return {
      dialog: false,
      selectedItemId: null,
      isDeleting: false,
      tableOptions: {
        page: this.pagination.page,
        itemsPerPage: this.pagination.limit,
      },
    }
  },
  watch: {
    tableOptions: {
      deep: true,
      handler(newVal, oldVal) {
        const changedPage = newVal.page !== oldVal.page
        const changedLimit = newVal.itemsPerPage !== oldVal.itemsPerPage
        if (changedPage || changedLimit) {
          this.$emit('updatePagination', {
            page: newVal.page,
            limit: newVal.itemsPerPage,
          })
        }
      },
    },
    pagination: {
      immediate: true,
      deep: true,
      handler(val) {
        this.tableOptions.page = val.page
        this.tableOptions.itemsPerPage = val.limit
      },
    },
  },
  computed: {
    headers() {
      return [
        { text: 'Vai trò giao việc', value: 'creator_role' },
        { text: 'Vai trò nhận việc', value: 'receivers' },
        { text: 'Thao tác', value: 'actions' },
      ]
    },
    footerTable() {
      return {
        'items-per-page-text': 'Số dòng mỗi trang',
        'items-per-page-options': [5, 10, 15],
        'items-per-page': this.tableOptions.itemsPerPage,
      }
    },
    groupedConfigs() {
      if (!Array.isArray(this.configsProp)) return []

      // Clone mảng để tránh mutate gốc
      const clone = [...this.configsProp]

      // Sắp xếp theo creator rồi receiver
      clone.sort((a, b) => {
        const creatorA = a.creator_role.description.toLowerCase() || ''
        const creatorB = b.creator_role.description.toLowerCase() || ''
        const receiverA = a.receiver_role.description.toLowerCase() || ''
        const receiverB = b.receiver_role.description.toLowerCase() || ''

        if (creatorA !== creatorB) {
          return creatorA.localeCompare(creatorB)
        } else {
          return receiverA.localeCompare(receiverB)
        }
      })

      return clone
    },
  },
  methods: {
    confirmDelete(item) {
      this.selectedItemId = item
      this.dialog = true
    },
    async deleteMapping() {
      if (!this.selectedItemId) return
      this.isDeleting = true
      try {
        const res = await this.$store.dispatch('configtaskroles/deleteConfigTaskRoles', this.selectedItemId._id)
        if (res) {
          this.$alert.success('Xoá thành công')
          this.$emit('onRefresh')
        } else {
          this.$alert.error('Xoá thất bại')
        }
      } catch (err) {
        console.error(err)
        this.$alert.error('Đã xảy ra lỗi khi xoá')
      } finally {
        this.dialog = false
        this.isDeleting = false
        this.selectedItemId = null
      }
    },
    toggleExpand(item) {
      this.$set(item, '_expanded', !item._expanded)
    },
    getVisibleReceiverText(item) {
      const list = item._expanded ? item.receivers : item.receivers.slice(0, 3)
      return list.map(r => r.description || '---').join(', ')
    },
  },
}
</script>

<style scoped>
.receiver-toggle {
  margin-left: 8px;
  color: #2196f3;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
}
</style>
